module.exports = __webpack_public_path__ + "static/media/DAI_BUSD_Cake.47792f40.png";